function toBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["1", "true", "yes", "sim", "on"].includes(normalized)) return true;
    if (["0", "false", "no", "nao", "não", "off", ""].includes(normalized)) return false;
  }
  return Boolean(value);
}

export function canManageEroticStories(user) {
  if (!user) return false;

  const flags = [
    user?.can_manage_erotic_stories,
    user?.canManageEroticStories,
    user?.user?.can_manage_erotic_stories,
    user?.user?.canManageEroticStories,
  ];

  for (const flag of flags) {
    if (flag !== undefined && flag !== null && flag !== "") {
      return toBoolean(flag);
    }
  }

  return Boolean(user?.is_superuser || user?.user?.is_superuser);
}
